import { XpTransactionType, XpTransactionScope } from 'src/types/xp';

export function getXpTransactionTypeLabel(type: XpTransactionType): string {
  switch (type) {
    case XpTransactionType.REFILL:
      return 'Earned';
    case XpTransactionType.REDEEM:
      return 'Spent';
    default:
      return type;
  }
}

export function getXpTransactionScopeLabel(scope: XpTransactionScope | null): string {
  if (!scope) return 'Manual';

  switch (scope) {
    case XpTransactionScope.LISTING_PUBLISH:
      return 'Listing Published';
    case XpTransactionScope.DEAL_CONFIRMED:
      return 'Deal Confirmed';
    case XpTransactionScope.BUY_CAR:
      return 'Car Purchased';
    case XpTransactionScope.SELL_CAR:
      return 'Car Sold';
    case XpTransactionScope.MANUAL:
      return 'Manual';
    default:
      return scope;
  }
}

export function formatXpAmount(amount: number, type: XpTransactionType): string {
  const sign = type === XpTransactionType.REFILL ? '+' : '-';
  return `${sign}${Math.abs(amount)}`;
}
